import { DefaultExposeGroupEnum } from '@goparrot/common';
var UserCustomExposeGroup;
(function (UserCustomExposeGroup) {
    UserCustomExposeGroup["INVITE_EMAIL"] = "invite_email";
    UserCustomExposeGroup["INVITE_EMAIL_CONFIRM"] = "invite_email_confirm";
    UserCustomExposeGroup["RESET_PASSWORD"] = "reset_password";
    UserCustomExposeGroup["RESET_PASSWORD_CONFIRM"] = "reset_password_confirm";
    UserCustomExposeGroup["CREATE_PHONE"] = "create_phone";
    UserCustomExposeGroup["CREATE_SSO"] = "create_sso";
    UserCustomExposeGroup["ACTIVATE_USER"] = "activate_user";
    UserCustomExposeGroup["INVITE_EMAIL_CONFIRM_FRANCHISE"] = "invite_email_confirm_franchise";
})(UserCustomExposeGroup || (UserCustomExposeGroup = {}));
export const UserExposeGroup = Object.freeze({ ...DefaultExposeGroupEnum, ...UserCustomExposeGroup });
//# sourceMappingURL=UserExposeGroup.js.map